import { baseUrlAssets as assets } from "lib/actions/endpoints/endpoints";
import { Endpoint } from "lib/types/Endpoint";

/**
 * The workspace's Autodesk (APS) connector.
 *
 * The registration routes carry no registration id: there is one APS app per
 * workspace, so the workspace addresses it.
 */
export const endpointsAutodesk = {
  registration: (workspaceId: number) =>
    `${assets}/workspace/${workspaceId}/autodesk/registration`,
  createRegistration: (workspaceId: number) =>
    ({
      method: "POST",
      url: `${assets}/workspace/${workspaceId}/autodesk/registration`,
    }) as Endpoint,
  updateRegistration: (workspaceId: number) =>
    ({
      method: "PATCH",
      url: `${assets}/workspace/${workspaceId}/autodesk/registration`,
    }) as Endpoint,
  deleteRegistration: (workspaceId: number) =>
    ({
      method: "DELETE",
      url: `${assets}/workspace/${workspaceId}/autodesk/registration`,
    }) as Endpoint,
  testRegistration: (workspaceId: number) =>
    ({
      method: "POST",
      url: `${assets}/workspace/${workspaceId}/autodesk/registration/test`,
    }) as Endpoint,
  requirements: (workspaceId: number) =>
    `${assets}/workspace/${workspaceId}/autodesk/registration/requirements`,
  accounts: (workspaceId: number) =>
    `${assets}/workspace/${workspaceId}/autodesk/accounts`,
  disconnectAccount: (workspaceId: number, connectedAccountId: number) =>
    ({
      method: "DELETE",
      url: `${assets}/workspace/${workspaceId}/autodesk/accounts/${connectedAccountId}`,
    }) as Endpoint,
  /**
   * The caller's own connected accounts, across every workspace they have
   * connected in. Each one carries the workspace that issued it.
   */
  userAccounts: `${assets}/autodesk/auth/useraccounts`,
  disconnectUserAccount: (connectedAccountId: number) =>
    ({
      method: "DELETE",
      url: `${assets}/autodesk/auth/useraccount/${connectedAccountId}`,
    }) as Endpoint,
  beginAuth: (workspaceId: number) =>
    ({
      method: "POST",
      url: `${assets}/workspace/${workspaceId}/autodesk/auth/begin`,
    }) as Endpoint,
  completeAuth: {
    method: "POST",
    url: `${assets}/autodesk/auth/complete`,
  } as Endpoint,
};
